var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.getAdditionalCostName(_vm.costType))?_c('span',{staticClass:"one-additional-cost-name"},[_vm._v("\n  "+_vm._s(_vm.getAdditionalCostName(_vm.costType))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }